import { render, staticRenderFns } from "./jiaoXue.vue?vue&type=template&id=4f20d1fe&scoped=true"
import script from "./jiaoXue.vue?vue&type=script&lang=js"
export * from "./jiaoXue.vue?vue&type=script&lang=js"
import style0 from "./jiaoXue.vue?vue&type=style&index=0&id=4f20d1fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f20d1fe",
  null
  
)

export default component.exports